export default "__VITE_ASSET__Cu4gDX9x__"